import React from 'react';
import lodash from 'lodash';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { optionMapping } from '../constants';
import { useOptionsExport } from '../useOptionsExport';
import { overviewExportConfig } from '../utils';

export const ExportAllButton = (props: {
  disabled: boolean;
  sections: string[];
  selectedDimensionTables: string[];
  onDone: () => void;
}) => {
  const { disabled, sections, selectedDimensionTables, onDone } = props;
  const initConfig = lodash.cloneDeep(overviewExportConfig);
  const configSections = [...initConfig.sections];
  const selectedSections = Array.from(new Set(sections.map((i) => optionMapping[i])));
  const resSections: { key: string; title: string; order?: string[]; selected?: string[] }[] = [];
  configSections.forEach((i) => {
    if (i.key === 'overview-dimension-tables' && selectedSections.includes(i.key)) {
      resSections.push({ ...i, selected: selectedDimensionTables });
      return;
    } else if (selectedSections.includes(i.key)) {
      resSections.push(i);
    }
  });
  initConfig.sections = resSections;
  const { triggerDownload } = useOptionsExport({ config: initConfig });

  const onClick = () => {
    triggerDownload();
    setTimeout(() => {
      onDone();
    }, 250);
  };

  return (
    <Button onClick={onClick} type="primary" icon={<DownloadOutlined />} disabled={disabled}>
      Export
    </Button>
  );
};
